import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import isDate from 'date-fns/isDate';
import isValidDate from 'date-fns/isValid';
import format from 'date-fns/format';
import addMinutes from 'date-fns/addMinutes';
import addHours from 'date-fns/addHours';
import addDays from 'date-fns/addDays';
import addWeeks from 'date-fns/addWeeks';
import addMonths from 'date-fns/addMonths';
import addYears from 'date-fns/addYears';
import subMinutes from 'date-fns/subMinutes';
import subHours from 'date-fns/subHours';
import subDays from 'date-fns/subDays';
import subWeeks from 'date-fns/subWeeks';
import subMonths from 'date-fns/subMonths';
import subYears from 'date-fns/subYears';
import getSeconds from 'date-fns/getSeconds';
import getMinutes from 'date-fns/getMinutes';
import getHours from 'date-fns/getHours';
import getDay from 'date-fns/getDay';
import getDate from 'date-fns/getDate';
import dfgetWeek from 'date-fns/getWeek';
import getMonth from 'date-fns/getMonth';
import getQuarter from 'date-fns/getQuarter';
import getYear from 'date-fns/getYear';
import getTime from 'date-fns/getTime';
import setSeconds from 'date-fns/setSeconds';
import setMinutes from 'date-fns/setMinutes';
import setHours from 'date-fns/setHours';
import setMonth from 'date-fns/setMonth';
import setQuarter from 'date-fns/setQuarter';
import setYear from 'date-fns/setYear';
import startOfDay from 'date-fns/startOfDay';
import startOfWeek from 'date-fns/startOfWeek';
import startOfMonth from 'date-fns/startOfMonth';
import startOfQuarter from 'date-fns/startOfQuarter';
import startOfYear from 'date-fns/startOfYear';
import endOfWeek from 'date-fns/endOfWeek';
import dfIsEqual from 'date-fns/isEqual';
import dfIsSameDay from 'date-fns/isSameDay';
import dfIsSameMonth from 'date-fns/isSameMonth';
import dfIsSameYear from 'date-fns/isSameYear';
import dfIsSameQuarter from 'date-fns/isSameQuarter';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import toDate from 'date-fns/toDate';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
export var DEFAULT_YEAR_ITEM_NUMBER = 12;
// ** Date Constructors **
function parseWeek(text) {
  // parse Wo
  // 只处理 yyyy-wo 格式
  var matchText = text.match(/[-\d]+/g);
  // 存在后缀
  if (!matchText || matchText[0] !== text) {
    return null;
  }
  var year = matchText.join('').split('-')[0];
  var weekStr = matchText.join('').split('-')[1];
  if (year && weekStr) {
    var firstDate = startOfYear(new Date(year));
    for (var j = 0; j <= 52; j += 1) {
      var nextWeek = addWeeks(firstDate, j);
      var nextWeekStr = format(nextWeek, 'w');
      if (nextWeekStr === weekStr) {
        return nextWeek;
      }
    }
  }
  return null;
}
export var localeParse = function localeParse(format) {
  return format.replace(/Y/g, 'y').replace(/D/g, 'd').replace(/gggg/, 'yyyy').replace(/g/g, 'G').replace(/([Ww])o/g, 'wo');
};
export function isNullEqual(value1, value2) {
  if (!value1 && !value2) {
    return true;
  }
  if (!value1 || !value2) {
    return false;
  }
  return undefined;
}
/**
 * @description 接受一个参数（若没有，返回当前），返回一个Date
 *
 * @export
 * @param {DateType} value
 * @returns
 */
export function newDate(value) {
  var d = value ? typeof value === 'string' || value instanceof String ? parseISO(value) : toDate(value) : new Date();
  return isValid(d) ? d : null;
}
export function parseDate(value, dateFormat) {
  var parsedDate = null;
  var strictParsingValueMatch = true;
  if (_includesInstanceProperty(dateFormat).call(dateFormat, 'wo')) {
    return parseWeek(value);
  }
  parsedDate = parse(value, dateFormat, new Date());
  if (!isValid(parsedDate)) {
    if (value.length > 0) {
      parsedDate = parse(value, _sliceInstanceProperty(dateFormat).call(dateFormat, 0, value.length), new Date());
    }
    if (!isValid(parsedDate)) {
      parsedDate = new Date(value);
    }
  }
  return isValid(parsedDate) && strictParsingValueMatch ? parsedDate : null;
}
// ** Date "Reflection" **
export { isDate };
export function isValid(date) {
  // 1000 年以后为有效值
  return isValidDate(date) && isAfter(date, new Date('1/1/1000'));
}
// ** Date Formatting **
export function formatDate(date, _format, _locale) {
  if (!isValid(date)) {
    return null;
  }
  // if (typeof _format === 'function') {
  //   return _format(date)
  // }
  return format(date, localeParse(_format));
}
// ** Date Setters **
export function setTime(date, _ref) {
  var _ref$hour = _ref.hour,
    hour = _ref$hour === void 0 ? 0 : _ref$hour,
    _ref$minute = _ref.minute,
    minute = _ref$minute === void 0 ? 0 : _ref$minute,
    _ref$second = _ref.second,
    second = _ref$second === void 0 ? 0 : _ref$second;
  return setHours(setMinutes(setSeconds(date, second), minute), hour);
}
export { setMinutes, setHours, setMonth, setQuarter, setYear };
// ** Date Getters **
export { getSeconds, getMinutes, getHours, getMonth, getQuarter, getYear, getDay, getDate, getTime };
export function getWeek(date) {
  return dfgetWeek(date);
}
// *** Start of ***
export function getStartOfDay(date) {
  return startOfDay(date);
}
export function getStartOfWeek(date) {
  return startOfWeek(date);
  // return startOfWeek(date)
}

export function getStartOfMonth(date) {
  return startOfMonth(date);
}
export function getStartOfYear(date) {
  return startOfYear(date);
}
export function getStartOfQuarter(date) {
  return startOfQuarter(date);
}
// *** End of ***
export function getEndOfWeek(date) {
  return endOfWeek(date);
}
// ** Date Math **
// *** Addition ***
export { addMinutes, addDays, addWeeks, addMonths, addYears, addHours };
// *** Subtraction ***
export { subMinutes, subHours, subDays, subWeeks, subMonths, subYears };
// ** Date Comparison **
export { isBefore, isAfter };
export function isSameYear(date1, date2) {
  var equal = isNullEqual(date1, date2);
  if (typeof equal === 'boolean') {
    return equal;
  }
  if (date1 && date2) {
    return dfIsSameYear(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
export function isSameMonth(date1, date2) {
  var equal = isNullEqual(date1, date2);
  if (typeof equal === 'boolean') {
    return equal;
  }
  if (date1 && date2) {
    return dfIsSameMonth(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
export function isSameQuarter(date1, date2) {
  var equal = isNullEqual(date1, date2);
  if (typeof equal === 'boolean') {
    return equal;
  }
  if (date1 && date2) {
    return dfIsSameQuarter(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
export function isSameDay(date1, date2) {
  var equal = isNullEqual(date1, date2);
  if (typeof equal === 'boolean') {
    return equal;
  }
  if (date1 && date2) {
    return dfIsSameDay(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
export function isEqual(date1, date2) {
  if (date1 && date2) {
    return dfIsEqual(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
export function getFormattedWeekdayInLocale(date, formatFunc, locale) {
  return formatFunc(formatDate(date, 'EEEE', locale));
}
export function getWeekdayMinInLocale(date, locale) {
  return formatDate(date, 'EEEEEE', locale);
}
export function getWeekdayShortInLocale(date, locale) {
  return formatDate(date, 'EEE', locale);
}
export function getMonthInLocale(month, locale) {
  return formatDate(setMonth(newDate(), month), 'LLLL', locale);
}
export function getMonthShortInLocale(month, locale) {
  return formatDate(setMonth(newDate(), month), 'LLL', locale);
}
export function getQuarterShortInLocale(quarter, locale) {
  return formatDate(setQuarter(newDate(), quarter), 'QQQ', locale);
}
/**
 * @description 根据传入时间，展示年份数自动生成年份范围
 *
 * @export
 * @param {DateType} date
 * @param { number} yearItemNumber
 * @returns
 */
export function getYearsPeriod(date, yearItemNumber) {
  var endPeriod = Math.ceil(getYear(date) / yearItemNumber) * yearItemNumber;
  var startPeriod = endPeriod - (yearItemNumber - 1);
  return {
    startPeriod: startPeriod,
    endPeriod: endPeriod
  };
}
export function getLowerBoundTime(hour, minute, second, hourStep, minuteStep, secondStep) {
  var lowerBoundHour = Math.floor(hour / hourStep) * hourStep;
  if (lowerBoundHour < hour) {
    return [lowerBoundHour, 60 - minuteStep, 60 - secondStep];
  }
  var lowerBoundMinute = Math.floor(minute / minuteStep) * minuteStep;
  if (lowerBoundMinute < minute) {
    return [lowerBoundHour, lowerBoundMinute, 60 - secondStep];
  }
  var lowerBoundSecond = Math.floor(second / secondStep) * secondStep;
  return [lowerBoundHour, lowerBoundMinute, lowerBoundSecond];
}
export var setYearOrMonthOfDate = function setYearOrMonthOfDate(date1, date2) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'year';
  var d1 = new Date(date1 || 0);
  var d2 = new Date(date2 || 0);
  if (type === 'year') {
    d1.setFullYear(d2.getFullYear());
  }
  if (type === 'month') {
    d1.setMonth(d2.getMonth());
  }
  return d1;
};